import { FunctionComponent, PropsWithChildren, useEffect, useRef } from 'react'
import {
  useFilters,
  useInteractionOutside
} from '@/modules/accredited-establishments/hooks'
import { useDrawer } from '@/global/hooks'
import { ResponsiveModal } from '@/modules/accredited-establishments/components'

interface ErrorModalTemplateProps extends PropsWithChildren {
  id: string
  active: boolean
}

const ErrorModalTemplate: FunctionComponent<ErrorModalTemplateProps> = ({
  id,
  active,
  children
}) => {
  const ref = useRef(null)

  const { isListView } = useFilters()

  const { close, isOpen, open } = useDrawer(id)

  useEffect(() => {
    if (isListView) {
      if (isOpen) close()
      return
    }

    if (active && !isOpen) {
      open()
    } else if (!active && isOpen) {
      close()
    }

    // we cannot add isOpen as dependency because it will prevent the modal from closing
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, isListView])

  useInteractionOutside({
    ref,
    callback: close,
    breakpoint: 0
  })

  return (
    <ResponsiveModal
      ref={ref}
      id={id}
      className='lg:bottom-[20%] lg:left-[50%] lg:translate-x-[-50%] z-50'
      desktopSettings={{ closeButton: true }}
      mobileSettings={{ heightMode: 'half-bottom' }}
    >
      <div className='w-full py-gl-spacing-12 lg:p-gl-spacing-16 desktop-short:p-gl-spacing-12 flex flex-col gap-gl-spacing-05 md:gap-gl-spacing-06 desktop-short:gap-gl-spacing-05 justify-center items-center'>
        {children}
      </div>
    </ResponsiveModal>
  )
}

export { ErrorModalTemplate }
